import {useState, useEffect} from 'react'
import ControlesSocio from './controles_socio.js'

export default function Importes(props) {
    const [importes, setImportes] = useState([])
    const [discip, setDiscip] = useState([])
    const [concepto, setConcepto] = useState([])
    const [pileta, setPileta] = useState([])

    function traer_valores () {
        fetch (props.back + 'admin/traer_importes', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => {
            const f = json.map(a => {
                return {grupo: a.grupo, valor: a._avg.valor}
            })
            setDiscip(f)
        })
        fetch(props.back + 'admin/traer_importes_cuentas' , {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => {
            const f = json.map(a => {
                return {cate: a.cate, valor: a.valor, id: a.id}
            })
            setImportes(f)
        })
        fetch(props.back + 'admin/traer_importes_pileta', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => {console.log(json);setPileta(json)})
    }

    function traer_valores_nosocio () {
        fetch (props.back + 'admin/traer_importes_nosocio', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => setConcepto(json))
    }

    useEffect( () => {
        traer_valores()
        traer_valores_nosocio()
    },[])
    
    
    function validar_dep(e, cual) {
        if (!isNaN(parseInt(e))) {
            const f = discip.map (a => {
                return a.grupo === cual ? {grupo: cual , valor: e} : a
            })
            setDiscip(f)
        }
    }
    function validar(e,cual) {
        if (!isNaN(parseInt(e))) {
            const t= importes.map (a => {
                return a.cate === cual ? {cate: cual, valor: e, id: a.id} : a 
            })
            setImportes(t)
        } else {
            const t= importes.map (a => {
                return a.cate === cual ? {cate: cual, valor: 0, id: a.id} : a 
            })
            setImportes(t)
        }
    }

    function validar_ing(e, cual) {
        if (!isNaN(parseInt(e))) {
            const f = concepto.map (a => {
                return a.motivo === cual ? {motivo: cual , valor: e, id: a.id} : a
            })
            setConcepto(f)
            console.log(f)
        }
    }

    function validar_pileta(e, cual, que) {
        if (!isNaN(parseInt(e))) {
            const anterior = pileta.find(a => a.id === cual)
            const nuevo = {grupo: anterior.grupo, id: cual, contado: que==='contado' ? e : anterior.contado, valor: que==='valor' ? e : anterior.valor, recargo: que==='recargo' ? e : anterior.recargo}
            const f = pileta.map(a => {
                return a.id === cual ? nuevo : a
            })
            setPileta(f)
            console.log(f)
        }
    }

    function guardar_cambios() {
        discip.map(a => {
            fetch (props.back + 'admin/update_actividades', {
                body : JSON.stringify(a),
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + props.token,
                    'Content-Type': 'application/json' 
                }
            })
            .then (response => response.json())
            .then (json => {})
         })
        importes.map (a => {
         fetch (props.back + 'admin/update_importes', {
            body : JSON.stringify(a),
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => props.setElegido(0))
        })
        concepto.map (a => {
            fetch (props.back + 'admin/update_importes_nosocio', {
               body : JSON.stringify(a),
               method: 'POST',
               headers: {
                   'Authorization': 'Bearer ' + props.token,
                   'Content-Type': 'application/json' 
               }
           })
           .then (response => response.json())
           .then (json => {})
           })
        update_pileta()
    }

    async function update_pileta() {
        const results = []
       for (const cual of pileta) {
            try {
                const response = await  fetch(props.back + 'admin/actualizar_pileta',{
                    body : JSON.stringify(cual),
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + props.token,
                        'Content-Type': 'application/json' 
                    }
                })
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
                const result = await response.json();
                results.push({ success: true, data: result })
            } catch (error) {
                results.push({ success: false, error: error.message, data: cual });
            }
        }
        return results
    }
    

    return (<>
        <div className="grid grid-cols-3 max-h-2/3 w-full">
            <div className="py-3 px-2 w-full text-center border-r-2 border-gray-600">
                <label className="text-lg font-semibold">
                    Valor Cuota Socio
                </label>
                {importes.map(a => {
                    return (<>
                        <div className="text-lg py-3 grid grid-cols-2">
                            <label className="px-2">{a.cate}</label>
                            <input 
                                className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-32 text-right"
                                type="text" 
                                value={a.valor}
                                onChange={(e => validar(e.target.value, a.cate))}
                            />
                        </div>
                    </>)}
                )}
                <ControlesSocio guardar={guardar_cambios} setElegido={props.setElegido}/>               
            </div>
          
            <div className="py-3 px-2 w-full text-center border-r-2 border-gray-600">
                <label className="text-lg font-semibold">
                    Valor Cuota Deportiva
                </label>
                <div className="overflow-y-auto h-4/5">
                {discip.map( a => {return (<>
                    <div className="text-lg py-3 grid grid-cols-2">
                        <label className="px-2">{a.grupo}</label>
                        <input 
                            className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-32 text-right"
                            type="text"
                            value={a.valor}
                            onChange={(e => validar_dep(e.target.value, a.grupo))}
                        />
                    </div>
                    </>)
                })}
                </div>
            </div>

            <div className="py-3 px-2 w-full text-center border-r-2 border-gray-600">
                <label className="text-lg font-semibold">
                    Valor Ingreso Diario
                </label>
                <div className="overflow-y-auto h-4/5">
                {concepto.map( a => {
                    return (<>
                        <div className="text-lg py-3 grid grid-cols-2">
                            <label className="px-2">{a.motivo}</label>
                            <input 
                                className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-32 text-right"
                                type="text"
                                value={a.valor}
                                onChange={(e => validar_ing(e.target.value, a.motivo))}
                            />
                        </div>
                    </>)
                })
                }
                 <label className="text-lg font-semibold mt-5">
                    Valor Abono pileta
                </label>
                <div className="">
                <div className="py-3 grid grid-cols-3 pl-5">
                    <label className='flex items-start'>Contado</label>
                    <label className='flex items-start'>Financiado</label>
                    <label className='flex items-start'>Recargo</label>
                </div>
                {pileta.map( a => {
                    return (<>
                        <div className="py-1 grid grid-cols-3 pl-5">
                             <label className="col-span-3 px-2 flex justify-center mb-3">{a.grupo}</label>
                            <input 
                                className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-24 text-right"
                                type="text"
                                value={a.contado}
                                onChange={(e => validar_pileta(e.target.value, a.id, 'contado'))}
                            />
                            <input 
                                className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-24 text-right"
                                type="text"
                                value={a.valor}
                                onChange={(e => validar_pileta(e.target.value, a.id, 'valor'))}
                            />
                            <input 
                                className="outline-0 border-b-2 border-gray-600 focus:border-red-400 w-24 text-right"
                                type="text"
                                value={a.recargo}
                                onChange={(e => validar_pileta(e.target.value, a.id, 'recargo'))}
                            />
                        </div>
                    </>)
                })
                }
                </div>
                <div className='py-5'></div>
                </div>
            </div>
        </div>
        </>)
}